/**
 * Retrieves the available quantity for a line item.
 *
 * This function returns `Infinity` if the `bypassNegativeQuantity` flag
 * is set to `true`, allowing unlimited quantity. Otherwise, it returns
 * the `availableQuantity` specified in the line item.
 *
 * @param {Object} lineItem - The line item object.
 * @param {boolean} lineItem.bypassNegativeQuantity - Flag indicating whether negative quantity is bypassed.
 * @param {number} lineItem.availableQuantity - The available quantity of the line item.
 * @returns {number} The available quantity or `Infinity` if bypassing negative quantities.
 */
export default function getAvailableQty(lineItem) {
    if (lineItem.bypassNegativeQuantity) {
        return Infinity;
    }
    return lineItem.availableQuantity;
}